import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import Role from "../helpers/role";

let userRole = localStorage.getItem("UserRoles");

class RankCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0,
            rows: 10,
        };
    }

    render() {
        const { pageSize, totalRecords, arraylist } = this.props;

        return (
            <div className="" style={{ paddingTop: "12px" }}>
                {this.renderCardData()}
                {arraylist && arraylist.length ? (
                    <div className="custom-paginator">
                        <Paginator
                            className="mb-3"
                            first={this.state.first}
                            rows={pageSize}
                            totalRecords={totalRecords}
                            onPageChange={(e) => this.onPaginatorChange(e)}
                        ></Paginator>
                    </div>
                ) : (
                    <div
                        className="card"
                        style={{ overflow: "hidden", position: "relative" }}
                    >
                        <div class="container">
                            <h6 className="resource-list-title no-item-card">
                                !-- No Items to Display --!
                            </h6>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    onPaginatorChange(event) {
        const { setUpdatedState } = this.props;
        this.setState({ first: event.first });
        setUpdatedState(event.page + 1);
    }
    renderCardData = () => {
        const { showSidePane, arraylist, DeleteRank, eyeclick } = this.props;
        return arraylist && arraylist.length
            ? arraylist.map((item, index) => {
                return (
                    <div
                        className="card"
                        style={{ overflow: "hidden", position: "relative" }}
                    >
                        <div className="p-2">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className={"col-md-10 col-sm-9 col-9 col-m-auto"}>
                                        <div className="row px-4">
                                            <div className={showSidePane ? "col-sm-8" : "col-sm-6"}>
                                                <span>
                                                    <strong>Name : </strong>
                                                    <span className="italicFont ">{item.rankName}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {userRole == Role.mmpl ? (<>
                                        <div className={"col-sm-3 col-md-2 col-m-auto col-3 d-flex justify-content-end"}>
                                        </div>
                                    </>) : (<>
                                        <div className={"col-sm-3 col-md-2 col-m-auto col-3 d-flex justify-content-end"}>
                                            <div
                                                className={showSidePane ? "text-center" : "text-center"}
                                            >
                                                <i
                                                    className="fa fa-edit fa-2x fa-lg click p-2"
                                                    aria-hidden="true"
                                                    onClick={() => eyeclick(item)}
                                                    style={{ color: " #1a3464" }}
                                                ></i>
                                                <i
                                                    className="fa fa-trash-o fa-2x click p-2"
                                                    aria-hidden="true"
                                                    style={{ color: " #1a3464" }}
                                                    onClick={() => DeleteRank(item)}
                                                ></i>
                                            </div>
                                        </div>
                                    </>)}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
            : null;
    };
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(RankCard)
);
